// src/components/roadmap/RoadmapTimeline.tsx
import React from 'react';
import {RoadmapPhaseCard} from './RoadmapPhaseCard';

interface TimelineData {
  filterAll: string;
  filterLaunched: string;
  filterInProgress: string;
  filterFuture: string;
}

interface PhasesData {
  phase1: object;
  phase2: object;
  phase3: object;
}

interface RoadmapTimelineProps {
  timelineData: TimelineData;
  phasesData: PhasesData;
}

export const RoadmapTimeline: React.FC<RoadmapTimelineProps> = ({ timelineData, phasesData }) => {
  // Convert phases object to an array for mapping
  const phasesArray = Object.entries(phasesData).map(([key, value]) => ({
    id: key,
    ...value,
  }));
  
  const phaseColors: Record<string, { statusColor: string, borderColor: string }> = {
    phase1: { statusColor: 'text-emerald-600', borderColor: 'border-emerald-500' },
    phase2: { statusColor: 'text-sky-600', borderColor: 'border-sky-500' },
    phase3: { statusColor: 'text-purple-600', borderColor: 'border-purple-500' },
  };

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        {/* Placeholder for filter buttons */}
        {/* <div className="flex justify-center gap-2 mb-12">
          <button className="px-4 py-2 text-sm font-semibold text-white bg-gray-900 rounded-full">{timelineData.filterAll}</button>
        </div> */}

        <div className="relative wrap overflow-hidden p-10 h-full">
          {/* Central Line */}
          <div 
            className="absolute border-2-2 border-slate-300 h-full border" 
            style={{ left: '50%' }}
          ></div>

          {/* Map through phases and render cards */}
          {phasesArray.map((phase, index) => (
            <RoadmapPhaseCard
              key={phase.id}
              index={index}
              phaseData={phase as any}
              statusColor={phaseColors[phase.id].statusColor}
              borderColor={phaseColors[phase.id].borderColor}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

